import React, { Fragment, useState } from "react";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import { Typography } from "@mui/material";
import Labels from "../labels/Labels";

export default function PayAnyDayAdvances(props) {
  const columns = [
    {
      field: "id",
      headerName: Labels.getLabel("payAnyDayAdvances.column.id", "ID"),
      width: 70,
      renderCell: (params) => {
        return (
          <Typography sx={{ fontSize: 12, mb: 0 }} gutterBottom>
            {params.row.periodStartDate}
          </Typography>
        );
      },
    },
    {
      field: "transactionDate",
      headerName: Labels.getLabel(
        "payAnyDayAdvances.column.transactionDate",
        "Transaction Date"
      ),
      width: 140,
      renderCell: (params) => {
        return (
          <Typography sx={{ fontSize: 12, mb: 0 }} gutterBottom>
            {params.row.transactionDate}
          </Typography>
        );
      },
    },
    {
      field: "amount",
      headerName: Labels.getLabel("payAnyDayAdvances.column.amount", "Amount"),
      width: 90,
      renderCell: (params) => {
        return (
          <Typography sx={{ fontSize: 12, mb: 0 }} gutterBottom>
            {params.row.amount}
          </Typography>
        );
      },
    },
    {
      field: "periodStartDate",
      headerName: Labels.getLabel(
        "payAnyDayAdvances.column.periodStartDate",
        "Start Date"
      ),
      width: 140,
      renderCell: (params) => {
        return (
          <Typography sx={{ fontSize: 12, mb: 0 }} gutterBottom>
            {params.row.periodStartDate}
          </Typography>
        );
      },
    },
    {
      field: "periodEndDate",
      headerName: Labels.getLabel(
        "payAnyDayAdvances.column.periodEndDate",
        "End Date"
      ),
      width: 140,
      renderCell: (params) => {
        return (
          <Typography sx={{ fontSize: 12, mb: 0 }} gutterBottom>
            {params.row.periodEndDate}
          </Typography>
        );
      },
    },
    {
      field: "pending",
      headerName: Labels.getLabel(
        "payAnyDayAdvances.column.pending",
        "Pending"
      ),
      width: 90,
      renderCell: (params) => {
        return (
          <Typography sx={{ fontSize: 12, mb: 0 }} gutterBottom>
            {params.row.pending}
          </Typography>
        );
      },
    },
  ];
  const { isLoading, isError, data } = props;
  return (
    <Fragment>
      {isLoading ? (
        <h4>{Labels.getLabel("payAnyDayAdvances.loading", "Loading...")}</h4>
      ) : !isError ? (
        <div style={{ height: 300, width: "100%" }}>
          <DataGrid
            columnVisibilityModel={{ id: false }}
            disableSelectionOnClick
            disableColumnFilter
            disableColumnSelector
            disableDensitySelector
            rows={data?.data}
            columns={columns}
            pageSize={10}
            rowsPerPageOptions={[10]}
            components={{ Toolbar: GridToolbar }}
            componentsProps={{
              toolbar: {
                showQuickFilter: false,
                quickFilterProps: { debounceMs: 500 },
              },
            }}
            sx={{
              "& .MuiButton-root": {
                display: "none",
              },
            }}
          />
        </div>
      ) : (
        <h4>
          {Labels.getLabel(
            "payAnyDayAdvances.error",
            "An error ocurred, please try again later..."
          )}
        </h4>
      )}
    </Fragment>
  );
}
